import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import logo from "../../assets/images/flight/footer1.png";
import { phoneNum } from "../../utils/globalVars";

import "./Footer.styles.css";
import moment from "moment";

const Footer = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleExpClick = (origin, dest) => {
    navigate({
      pathname: "/flights",
      search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
        "YYYY-MM-DD"
      )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
    });
  };

  return (
    <footer className="cm-footer-container">
      <div className="cm-fixed-footer-cta cm-txt-center cm-white-bg box-shadow-2 cm-wt-600">
        <p>
          Save Instantly on Unpublished Deals - CALL NOW{" "}
          <a href={`tel:${phoneNum.value}`} className="cm-prim-bg cm-white-col">
            <i className="fa-solid fa-phone"></i>
            {phoneNum.label}
          </a>
        </p>
      </div>
      <div className="cm-footer-top">
        <div className="container cm-flex-type-2 cm-flex-align-fs">
          <div className="cm-footer-col cm-wd-25 cm-lr-pad cm-footer-col1">
            <h3>About us</h3>
            <p>
              Trian Fly is established to streamline the online flight booking
              experience and touch base with our customers' requirements. You
              can find great deals on flight tickets and plan a budget-efficient
              trip with our one-stop flight booking platform. Customer
              satisfaction is the center of our goals, and we ensure to align
              with your travel needs.
            </p>
          </div>
          <div className="cm-footer-col cm-wd-25 cm-lr-pad cm-footer-col2">
            <h3>Our Destination</h3>
            <ul className="cm-menu-ul">
              <li onClick={(e) => handleExpClick("DFW", "MXP")}>
                <Link to="">Dallas</Link>
              </li>
              <li onClick={(e) => handleExpClick("RSW", "DEL")}>
                <Link to="">Florida</Link>
              </li>
              <li>
                <Link to="" onClick={(e) => handleExpClick("NCE", "MXP")}>
                  California
                </Link>
              </li>
              <li>
                <Link to="">
                  <li onClick={(e) => handleExpClick("NCE", "MXP")}>
                    <Link to="">New York</Link>
                  </li>
                </Link>
              </li>
              <li>
                <Link to="" onClick={(e) => handleExpClick("NCE", "MXP")}>
                  Washington
                </Link>
              </li>
            </ul>
          </div>
          <div className="cm-footer-col cm-wd-25 cm-lr-pad cm-footer-col3">
            <h3>Reach us at</h3>
            <ul className="cm-menu-ul">
              <li>
                <a href={`tel:${phoneNum.value}`}>
                  <i className="fa-solid fa-phone"></i>
                  <span>{phoneNum.label}</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@trianfly.com">
                  <i className="fa-solid fa-envelope"></i>
                  <span>info@trianfly.com</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-solid fa-location-dot"></i>
                  <address>
                    47 Eliot Street, NATICK, MA,<br></br> USA 01760
                  </address>
                </a>
              </li>
            </ul>
          </div>
          <div className="cm-footer-col cm-wd-25 cm-lr-pad cm-footer-col2 social-links">
            <h3>Social Links</h3>
            <ul>
              <li>
                <a href="https://x.com/TrianFly">
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/trianfly/">
                  <i class="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/people/Trian-Fly/61567805876793/">
                  <i class="fa-brands fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://www.pinterest.com/trianfly/">
                  <i class="fa-brands fa-pinterest"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="cm-footer-bottom cm-sec-bg cm-white-col">
        <div className="cm-page-center cm-txt-center">
          <p>© 2023. All rights reserved.</p>
          <p className="cm-flex-type-2">
            <Link to="/privacy-policy">Privacy Policy</Link> |
            <Link to="/terms-and-conditions">Terms & Conditions</Link> |
            <Link to="/disclaimer">Disclaimer</Link> |
            <Link to="/refund-policy">Refund Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
